import React, { Component } from 'react'
import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'

class SelectedFiltersList extends Component {
  render () {
    const {
      filterSelected,
      listObject,
      handleFilterChanged
    } = this.props

    return (
      <div>
        {filterSelected && filterSelected.category && listObject
          ? filterSelected.category.map((item, index) => {
            let filteredSubcategory = listObject.filter(value => {
              return String(value.id) === String(item)
            })
            return filteredSubcategory.length <= 0 ? null : (
              <div
                key={'subcategory_' + index}
                className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius'
              >
                <div className='row mx-0 align-items-center h-100'>
                  <a role='button' href='javascript:void(0)'
                    className='txt-subtitle txt-font-body color-ui-2'>
                    {filteredSubcategory[0].description}
                    <Icon
                      iconName='icon_close'
                      className='color-ui-3 cursor'
                      action='remove'
                      value={filteredSubcategory[0].id}
                      onClick={handleFilterChanged('category')}
                    />
                  </a>
                </div>
              </div>
            )
          })
          : null}
      </div>
    )
  }
}
SelectedFiltersList.propTypes = {
  filterSelected: PropTypes.object,
  listObject: PropTypes.array,
  handleFilterChanged: PropTypes.func.isRequired
}

export default SelectedFiltersList



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Filters/SelectedFiltersList.js